import {NoticeKind, noticeKinds} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<NoticeKind>;

export const NoticeKindSelect = (props: Props) => {
  const {options = noticeKinds, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
